export default "__VITE_ASSET__AV6ykiI$__"